export default __webpack_public_path__ + "static/media/excel.89f16f1a.svg";